import {
	onReceive as pushSourceEvent,
	onSend as pushConvertedEvent
} from './shiftLeakDetection';

export const project = 'shiftDr'; // need this for when we dynamically import utils

// dataMapper.js calls this on every raw event received, before rule matching.
// Stage 1 is scoped to events.widgetUserEvent[] only and must never fire in
// preview, same as the real Shift send below.
export const onReceive = ({ eventData, flags, win, preview, event }) => {
	if (preview || event !== 'widgetUserEvent') return;
	pushSourceEvent({ win, eventData, flags });
};

export const sending = ({ data, eventData, event, flags, preview, win }) => {
	// The length of the data keys matter because we are not processing empty payloads
	// This is a workaround to utilize the drInitialClick trigger for the SDP autoOpen which requires a standalone drInitialClick event
	if (Object.keys(data).length) {
		const { events, digRet, ...rest } = data;
		const reportsForEventViewer = [
			{
				events,
				name: project,
				payload: {
					digRet,
					...rest
				},
				sender: 'sd'
			}
		];
		const reportsForNewRelic = [
			{
				clientEventName: events,
				sender: 'win.sd'
			}
		];

		if (!preview && win.sd) {
			win.sd('dataLayer', data);
			win.sd('send');

			// same scope as Stage 1's onReceive above
			if (event === 'widgetUserEvent') {
				pushConvertedEvent({
					win,
					eventData,
					sdEventName: events,
					flags
				});
			}
		}

		return {
			reportsForEventViewer,
			reportsForNewRelic
		};
	}
	return {
		reportsForEventViewer: [],
		reportsForNewRelic: []
	};
};

export const vehicleStatus = ({ vehicles }) => {
	const vehicle = vehicles[0];
	if (vehicle.newOrUsed.toUpperCase() === 'NEW') {
		return 'New';
	} else if (vehicle.newOrUsed.toUpperCase() === 'USED') {
		if (vehicle.certified.toUpperCase() === 'CERTIFIED') {
			return 'CPO';
		} else {
			return 'Used';
		}
	} else {
		return '';
	}
};

export const isGtp = ({ eventData }) => {
	if (window.DDC.dataLayer.site.profiles.includes('subaruprofile')) {
		if (eventData?.sourceData?.tradeInSource === 'SUBARUGTP') {
			return 'true';
		}
		return 'false';
	}
	return '{{REMOVEKEY}}';
};
